import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Select, MenuItem } from '@mui/material';
import { UserStatusType, User, USER_COLLECTION } from '../type';
import { useEffect, useState } from 'react';
import { formatDate } from '../utils/dateUtils';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase_config';

interface UserTableProps {
  data: User[];
  onUserSelect: (user: User) => void;
}

export const UserTable = ({
  data,
  onUserSelect,
}: UserTableProps) => {

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pagedData, setPagedData] = useState<User[]>([]);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  
  const handleStatusChange = async (uid: string, newStatus: UserStatusType) => {
    await updateDoc(doc(db, USER_COLLECTION, uid), { status: newStatus });
    const user = data.find(u => u.uid === uid);
    if (user) {
      user.status = newStatus;
      const pagedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
      setPagedData(pagedData);
    }
  };

  useEffect(() => {
    if (data?.length) {
      const pagedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
      setPagedData(pagedData);
    } else {
      setPagedData([]);
    }
  }, [data, page, rowsPerPage]);

  return (
    <Box sx={{ flex: 4 }}>
        <TableContainer>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>사용자 ID</TableCell>
                <TableCell>이메일</TableCell>
                <TableCell>이름</TableCell>
                <TableCell>전화번호</TableCell>
                <TableCell>기업 사용자</TableCell>
                <TableCell>가입일</TableCell>
                <TableCell>상태</TableCell> {/* New column */}
                <TableCell>선택 약관 동의</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pagedData.map((row, index) => (
                <TableRow key={row.uid || `user-${index}`} hover style={{ cursor: 'pointer' }} onClick={() => onUserSelect(row)}>
                  <TableCell>{row.uid}</TableCell>
                  <TableCell>{row.email}</TableCell>
                  <TableCell>{row.displayName}</TableCell>
                  <TableCell>{row.phoneNumber}</TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: 'inline-block',
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        backgroundColor: row.isEnterpriseUser ? '#e8f5e8' : '#f5f5f5',
                        color: row.isEnterpriseUser ? '#2e7d32' : '#666',
                      }}
                    >
                      {row.isEnterpriseUser ? '기업' : '일반'}
                    </Box>
                  </TableCell>
                  <TableCell>{formatDate(row.createdAt)}</TableCell>
                  <TableCell>
                    <Select
                      value={row.status}
                      size="small"
                      onClick={(e) => e.stopPropagation()} // Prevent row click
                      onChange={(e) => handleStatusChange(row.uid, e.target.value)}
                    >
                      <MenuItem value="pending_approval">승인 대기</MenuItem>
                      <MenuItem value="approved">승인됨</MenuItem>
                      <MenuItem value="rejected">거절됨</MenuItem>
                      <MenuItem value="disabled">비활성화</MenuItem>
                      {/* <MenuItem value="banned">차단됨</MenuItem> */}
                    </Select>
                  </TableCell>
                  <TableCell>{row.termsAgreed.optional ? '동의' : '미동의'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={data.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
    </Box>
  );
}; 